import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import './Tooltip.css';

export const Tooltip = ({ 
  children, 
  content, 
  title,
  description,
  placement = "top",
  delay = [200, 0],
  duration = [200, 150],
  trigger = "mouseenter"
}) => {
  // If no content is provided, just render children
  if (!content && !title && !description) return children;

  // Create professional content structure
  const renderContent = () => {
    if (title || description) {
      return (
        <div className="tooltip-content">
          {title && <div className="tooltip-title">{title}</div>}
          {description && <div className="tooltip-description">{description}</div>}
        </div>
      );
    }
    return content;
  };

  return (
    <Tippy
      content={renderContent()}
      placement={placement}
      arrow={true}
      delay={delay}
      duration={duration}
      theme="professional"
      maxWidth={300}
      interactive={true}
      trigger={trigger}
    >
      {children}
    </Tippy>
  );
}; 